// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3S7ls","head":"Table_head__Y5d8h","col":"Table_col__1FiED"};